const byName = (a: ProviderTileData, b: ProviderTileData) =>
  a.name.localeCompare(b.name);

const getVisibleProviders = (
  providers: ProviderTileData[],
  query: string,
  sort: ProvidersSortOption,
) => {
  const term = query.trim().toLowerCase();
  const matched = term
    ? providers.filter((provider) => provider.name.toLowerCase().includes(term))
    : providers;

  if (sort === "name") {
    return [...matched].sort(byName);
  }
  return matched;
};

export default getVisibleProviders;
